// La app de las tiendas es un WebView que carga docente.carnet.plus y Android lo
// mantiene vivo en segundo plano por horas o días: sin esto, el docente sigue con
// el JS y los datos de cuando la abrió (y una pantalla diferida de un deploy
// anterior falla con "Failed to fetch dynamically imported module").

export const MINUTOS_PARA_RECARGAR = 60;
export const EVENTO_VOLVER = 'docente:volver';
const CLAVE_RECARGA = 'docente_recarga_por_error';
const MENSAJE_SIN_CONEXION = 'Sin conexión con el servidor. Revisa tu internet e inténtalo de nuevo.';

// Guardados en curso (marcar asistencia, etc.): nunca recargar en medio de uno.
let operaciones = 0;
export const operacionesEnCurso = () => operaciones;
export async function conOperacion(tarea) {
  operaciones += 1;
  try { return await tarea(); } finally { operaciones -= 1; }
}

const fechaLocal = (ms) => {
  const d = new Date(ms);
  return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
};

/**
 * Motivo para recargar al volver, o null: 'dia' (cambió el día: volver a Mis clases),
 * 'version' (hay una versión nueva publicada) o 'tiempo' (estuvo oculta mucho rato).
 */
export function motivoRecarga({ buildActual, buildPublicado, ocultoDesde, ahora }) {
  if (ocultoDesde && fechaLocal(ocultoDesde) !== fechaLocal(ahora)) return 'dia';
  if (buildPublicado && buildActual && buildPublicado !== buildActual) return 'version';
  if (ocultoDesde && ahora - ocultoDesde >= MINUTOS_PARA_RECARGAR * 60000) return 'tiempo';
  return null;
}

export function esErrorDeCargaDeModulo(error) {
  return /dynamically imported module|importing a module script failed|error loading dynamically imported|unable to preload css/i
    .test(String(error?.message || error || ''));
}

export function esErrorDeRed(error) {
  return error instanceof TypeError && /failed to fetch|network|load failed|networkerror/i.test(error.message || '');
}

export function errorSinConexion() {
  return new Error(MENSAJE_SIN_CONEXION);
}

/** Recarga por error de carga a lo sumo una vez por minuto (evita bucles si el sitio está caído). */
export function recargarUnaVez({ storage = sessionStorage, ahora = Date.now(), recargar = () => window.location.reload() } = {}) {
  try {
    const ultima = Number(storage.getItem(CLAVE_RECARGA) || 0);
    if (ultima && ahora - ultima < 60000) return false;
    storage.setItem(CLAVE_RECARGA, String(ahora));
  } catch { /* sin storage: recargar igual una vez */ }
  recargar();
  return true;
}

/** import() de una pantalla diferida que, si su archivo ya no existe tras un deploy, recarga la app. */
export function importarConRecarga(importar, opciones) {
  return importar().catch((error) => {
    if (esErrorDeCargaDeModulo(error) && recargarUnaVez(opciones)) return new Promise(() => {});
    throw error;
  });
}
